export default {
  REPORTS_D3_ERROR: 'There was an error with rendering this report',
  REPORTS_ATTENDEE_LIST: 'Attendee List',
  REPORTS_ATTENDEE_LIST_REPORT: 'Attendee List Report',
  REPORTS_ATTENDEE_LIST_HEADER_TICKET_OPTION: 'Ticket Option',
  REPORTS_ATTENDEE_LIST_HEADER_PURCHASED: 'Purchased',
  REPORTS_ATTENDEE_LIST_HEADER_USED: 'Used',
  REPORTS_ATTENDEE_LIST_TABLE_HEADER: 'All Attendees ({count})',
  REPORTS_CAMPAIGN_OVERVIEW: 'Campaign Overview',
  REPORTS_CURRENT_STATE_DASHBOARD: 'Dashboard',
  REPORTS_CURRENT_STATE_DASHBOARD_HEADER: '{orgName} Dashboard',
  REPORTS_DASHBOARD: 'Dashboard',
  REPORTS_CONTRIBUTIONS: 'Contributions',
  REPORTS_CONTRIBUTIONS_LIST: 'Contributions List',
  REPORTS_CONTRIBUTIONS_OVER_TIME: 'Contributions Over Time',
  REPORTS_CONTRIBUTIONS_BY_CAMPAIGN: 'Contributions By Campaign',
  REPORTS_CONTRIBUTIONS_BY_CATEGORY: 'Contributions By Category',
  REPORTS_CONTRIBUTIONS_BY_TYPE: 'Contributions By Type',
  REPORTS_CONTRIBUTION_DISTRIBUTION: 'Contribution Distribution',
  REPORTS_EXPORT_CHOICE_DIALOG_HEADER: 'Export Contribution List',
  REPORTS_EXPORT_CHOICE_DIALOG_DESCRIPTION:
    'How would you like to export your data?',
  REPORTS_EXPORT_CHOICE_DIALOG_QUICKBOOKS_CTA: 'Export for QuickBooks',
  REPORTS_EXPORT_CHOICE_DIALOG_CSV_CTA: 'Download as .csv',
  REPORTS_EXPORT_QUICKBOOKS_DESCRIPTION: 'Description',
  REPORTS_FILTER_ASSIGNED_EMPLOYEE: 'Assigned Employee',
  REPORTS_FILTER_DAILY: 'Daily',
  REPORTS_FILTER_END_DATE_LABEL: 'End Date',
  REPORTS_FILTER_MONTHLY: 'Monthly',
  REPORTS_FILTER_REPORT_TYPE: 'Report Type',
  REPORTS_FILTER_START_DATE_LABEL: 'Start Date',
  REPORTS_FILTER_DATE_TYPE_LABEL: 'Date',
  REPORTS_FILTER_DATE_TYPE_FISCAL_YTD: 'Fiscal YTD',
  REPORTS_FILTER_DATE_TYPE_CALENDAR_YTD: 'Calendar YTD',
  REPORTS_FILTER_DATE_TYPE_CUSTOM_DATES: 'Custom Dates',
  REPORTS_FILTER_DATE_TYPE_ALL_TIME: 'All Time',
  REPORTS_FILTER_DATE_TYPE_LAST_30_DAYS: 'Last 30 Days',
  REPORTS_FILTER_DATE_TYPE_LAST_6_MONTHS: 'Last 6 Months',
  REPORTS_FILTER_RESET: 'Reset Filters',
  REPORTS_FILTER_WEEKLY: 'Weekly',
  REPORTS_GRANTS: 'Grants',
  REPORTS_GRANTS_REPORT: 'Grants Report',
  REPORTS_GRANTS_AWARDED: 'Grants Awarded',
  REPORTS_GRANTS_DATE_AWARDED: 'Awarded',
  REPORTS_GRANTS_RECEIVED: 'Grants Received',
  REPORTS_NEW_DONOR_GROWTH: 'New Donor Growth',
  REPORTS_NEW_DONOR_GROWTH_REPORT: 'New Donor Growth Report',
  REPORTS_NEW_DONOR_GROWTH_SUMMARY_TOTAL: 'Total Donors',
  REPORTS_NEW_DONOR_GROWTH_SUMMARY_ONE_TIME: 'One Time Donors',
  REPORTS_NEW_DONOR_GROWTH_SUMMARY_RETURNING: 'Returning Donors',
  REPORTS_NEW_DONOR_GROWTH_LIST: 'New Donor List',
  REPORTS_NEW_DONOR_GROWTH_TABLE_HEADING_NAME: 'Name',
  REPORTS_NEW_DONOR_GROWTH_TABLE_HEADING_CATEGORY: 'Category',
  REPORTS_NEW_DONOR_GROWTH_TABLE_HEADING_DONATIONS: 'Donations',
  REPORTS_NEW_DONOR_GROWTH_TABLE_HEADING_CREATED: 'Created',
  REPORTS_PAGE_FILTER_MODAL_TITLE: 'Filter Report',
  REPORTS_PAGE_TITLE: 'Reports',
  REPORTS_PAGE_TITLE_ICON_ALT: 'Reports Icon',
  REPORTS_PLEDGE: 'Pledges',
  REPORTS_PLEDGE_ALL_PLEDGES: 'All Pledges',
  REPORTS_PLEDGE_BREAKDOWN: 'Pledge Breakdown',
  REPORTS_PLEDGE_BREAKDOWN_NO_DATA: 'No pledge data available',
  REPORTS_PLEDGE_BREAKDOWN_OUTSTANDING: 'Outstanding',
  REPORTS_PLEDGE_BREAKDOWN_RECEIVED: 'Received',
  REPORTS_PLEDGE_CONSTITUENT: 'Constituent',
  REPORTS_PLEDGE_PLEDGED: 'Pledged',
  REPORTS_PLEDGE_RECEIVED: 'Received',
  REPORTS_PLEDGE_PLEDGE_DATE: 'Pledge Date',
  REPORTS_PLEDGE_DUE_DATE: 'Due Date',
  REPORTS_PLEDGE_TOTAL_PLEDGES: 'Total Pledges',
  REPORTS_PLEDGES_REPORT: 'Pledges Report',
  REPORTS_UPDATE_REPORT: 'Update Report',
  REPORTS_TOTAL_VALUE: 'Total Value',
  REPORTS_TOTAL_DONATIONS: 'Total Donations',
  REPORTS_TOTAL_CONTRIBUTIONS: 'Total Contributions',
  REPORTS_TOTAL_DONORS: 'Total Donors',
  REPORTS_TOTAL_CONTRIBUTORS: 'Total Contributors',
  REPORTS_TOTAL_RECEIVED: 'Total Received',
  REPORTS_AVERAGE_CONTRIBUTION: 'Average Contribution',
  REPORTS_TOTAL_HOURS: 'Total Hours',
  REPORTS_INKIND_VALUE: 'In-Kind Value',
  REPORTS_TOTAL_EARNED_REVENUE: 'Total Earned Revenue',
  REPORTS_DONOR_LIST: 'Donor List',
  REPORTS_CONTRIBUTOR_LIST: 'Contributor List',
  REPORTS_NO_RESULTS_FOUND: 'No Results Found',
  REPORTS_PLEASE_ADJUST: 'Please adjust your report settings and try again.',
  REPORTS_LOADING_ERROR:
    'There was a problem loading the data. Please try again.',
  REPORTS_LYBUNT: 'LYBUNT',
  REPORTS_LYBUNT_REPORT: 'LYBUNT Report',
  REPORTS_SYBUNT: 'SYBUNT',
  REPORTS_SYBUNT_REPORT: 'SYBUNT Report',
  REPORTS_TOTAL_DONATIONS_LY: 'Total Donations Last Year',
  REPORTS_LIFETIME_DONATIONS: 'Lifetime Donations',
  REPORTS_NO_DATA: 'No data available',
  REPORTS_RECURRING_CONTRIBUTIONS: 'Recurring Contributions',
  REPORTS_RECURRING_PLANS: 'Recurring Plans',
  REPORTS_RECURRING_CONTRIBUTIONS_REPORT: 'Recurring Contributions Report',
  REPORTS_CANCELLED_PLANS: 'Canceled Plans',
  REPORTS_TOTAL_RECURRING_CONTRIBUTIONS: 'Total Recurring Contributions',
  REPORTS_RECURRING_CONTRIBUTIONS_INCOME: 'Recurring Contributions Income',
  REPORTS_CANCELLATIONS_OVER_TIME: 'Cancellations Over Time',
  REPORTS_RECURRING_CONTRIBUTIONS_SOURCE: 'Recurring Contributions Source',
  REPORTS_ONE_TIME_VS_RECURRING_CONTRIBUTIONS:
    'One Time vs. Recurring Contributions',
  REPORTS_ONE_TIME_DONATION: 'One Time',
  REPORTS_RECURRING_DONATION: 'Recurring',
  REPORTS_PROJECTED: '{value} projected',
  REPORTS_PLANS: '{formattedValue} plans',
  REPORTS_DATE: 'Date',
  REPORTS_CONTRIBUTION: 'Contribution',
  REPORTS_CONSTITUENT: 'Constituent',
  REPORTS_TYPE: 'Type',
  REPORTS_CAMPAIGN: 'Campaign',
  REPORTS_METHOD: 'Method',
  REPORTS_SOURCE: 'Source',
  REPORTS_CONTRIBUTION_SOURCE: 'Source',
  REPORTS_RESTRICTIONS: 'Restrictions',
  REPORTS_CREATED: 'Created',
  REPORTS_RESTRICTIONS_UNRESTRICTED: 'Unrestricted',
  REPORTS_PLEDGE_AMOUNT: ' of {amount} ',
  REPORTS_CONTRIBUTIONS_ASSOCIATED_WITH_PLEDGES:
    'Contributions associated with pledges',
  REPORTS_CONTRIBUTED_BY: 'Contributed By',
  REPORTS_DEDICATION: 'Dedications',
  REPORTS_DEDICATION_TYPE: 'Dedication Type',
  REPORTS_DEDICATION_LIST_TABLE_HEADER: 'All Dedications ({count})',
  REPORTS_COMPARE_DATA: 'Compare Data',
  REPORTS_NO_COMPARISON: 'No Comparison',
  REPORTS_PREVIOUS_YEAR: 'Previous Year',
  REPORTS_TIME_INTERVAL: 'Time Interval',
  REPORTS_COMPARISON_DAYS: 'Days',
  REPORTS_COMPARISON_MONTHS: 'Months',
  REPORTS_COMPARISON_YEARS: 'Years',
  REPORTS_COMPARISON_LEGEND_CUSTOM_DATES: '{startDate} - {endDate}',
  REPORTS_COMPARISON_LEGEND_PREVIOUS: `Previous 
{dateType, select,
  allTime { All Time}
  calendarYtd { Calendar YTD}
  customDates { Custom Dates}
  last30Days { Last 30 Days}
  last6Months { 6 Months}
  other {}
}`,
  REPORTS_COMPARISON_LEGEND_CURRENT: `Current 
{dateType, select,
  allTime { All Time}
  calendarYtd { Calendar YTD}
  customDates { Custom Dates}
  last30Days { Last 30 Days}
  last6Months { 6 Months}
  other {}
}`,
  REPORTS_TOTAL_ASKED_VALUE: 'Total Asked Value',
  REPORTS_TOTAL_PROJECTED_VALUE: 'Total Projected Value',
  REPORTS_TOTAL_EXPECTED_VALUE: 'Total Expected Value',
  REPORTS_TOTAL_OPPORTUNITIES: 'Total Opportunitites',
};
